import { Injectable } from '@angular/core';
import { AuthorizedUser, ResolvedItemCache, UserStorage } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetsUser } from 'assets-model';

@Injectable({
  providedIn: 'root',
})
export class AssetsUserStorage extends ResolvedItemCache<AssetsUser> {

  constructor(private userStorage: UserStorage) {
    super(null);
    this.userStorage.itemChanges().subscribe(item => this.resolve(false));
  }

  public reResolve(): Observable<AssetsUser> | null {
    return this.userStorage.resolve().pipe(map(user => AssetsUser.assignAs(user)));
  }

  protected isEqualItem(item: AssetsUser, compare: AssetsUser): boolean {
    return AuthorizedUser.equalsAuthenticatedUser(item, compare);
  }

}
